export default __webpack_public_path__ + "static/media/Group 693.ef77afdf.png";